import axios from 'axios';
import {webfulTrack} from '../app/utils/webful';
import store from '../store';
import {
	findLabels,
	findLabelsByType,
	getSelectedContactsGroup,
	labelsPageNumber,
	labelStateUpdating,
	checkComponentRendering, selectSeveralContactsGroups
} from './contactsGroupItemActions';
import {
	API_GET_GROUP_COLLABORATORS_URL,
	API_POST_CONTACT_GROUPS_URL,
	API_ROOT, checkEmailFormat, sharedWordRemove, translate
} from '../app/utils';
import {getProfile} from './profileActions';
import {isSyncing} from './syncStatusActions';
import {isEmailValid, isEmpty} from './addCollaboratorActions';
import {isSearchingContacts, targetedContact, setDetailsForContactCard} from './contactActions';
import {guidedTours} from './guidedToursActions';
import {findUsers} from './usersListActions';
import {confirmFreeLicensesPopup} from './popupActions';
import {msgSharingDetailsBar} from './msgBarActions';
import {findDirectoryGroups} from './directoryGroupActions';
import {findSystemGroups} from './systemGroupActions';

export function findCollaborators(labelId, pageSize, explicitOwnerId) {

	return function (dispatch, getState) {

		let ownerId = explicitOwnerId || '';
		const myObj = getState().contactReducer.contactCardDetails;

		let cleanLabelId = labelId;
		if (typeof cleanLabelId === 'string' && cleanLabelId.includes('-') && /^\d+-/.test(cleanLabelId)) {
			const parts = cleanLabelId.split('-');
			cleanLabelId = parts[0];
			if (!ownerId) {
				ownerId = parts[1];
			}
		}

		if (!ownerId) {
			if (Object.keys(myObj).length > 1) {
				ownerId = getState().contactReducer.contactCardDetails.ownerId;
				labelId = getState().contactReducer.contactCardDetails.groupId;
			} else if (cleanLabelId === "6" || cleanLabelId === 6) {
				ownerId = getState().profileReducer.getProfile.id;
			} else if (getState().contactsGroupItemReducer.selectOneLabelFromPopup) {
				ownerId = getState().contactsGroupItemReducer.selectOneLabelFromPopup.ownerId;
			} else if (getState().sharingDetailsReducer.getSharingDetailsPopup && getState().sharingDetailsReducer.getSharingDetailsPopup[4]) {
				ownerId = getState().sharingDetailsReducer.getSharingDetailsPopup[4];
			} else if (getState().contactsGroupItemReducer.getSelectedContactsGroup) {
				ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;
			}
		}

		labelId = cleanLabelId;

		let request = '';

		if (pageSize) {
			request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?ownerId=' + ownerId + '&pageSize=' + pageSize + '&page=' + getState().sharingDetailsReducer.collaboratorsPageNumber;
		} else {
			request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?ownerId=' + ownerId + '&page=' + getState().sharingDetailsReducer.collaboratorsPageNumber;
		}

		axios.get(request, {withCredentials: true}).then(response => {

			/*
			* To avoid the previous page loading when scrollTop = 0 when label list is reloading
			* */

			/*if(document.querySelector(".list-of-collaborators-details-content") && store.getState().sharingDetailsReducer.collaboratorsPageNumber > 1){
				document.querySelector(".list-of-collaborators-details-content").scrollTop = 1;
			}*/

			dispatch({
				type: 'FIND_COLLABORATORS',
				payload: response.data
			});

			if(getState().sharingDetailsReducer.isSharing) {
				dispatch(isSharing(false));
			}

			dispatch(checkUpdates());

			let selectedLabel;

			if (getState().contactsGroupItemReducer.selectOneLabelFromPopup) {
				selectedLabel = getState().contactsGroupItemReducer.selectOneLabelFromPopup.id;

			} else {
				selectedLabel = getState().contactsGroupItemReducer.getSelectedContactsGroup.id;
			}

			if (!selectedLabel && response.data.collaborators === undefined) {
				dispatch(getSelectedContactsGroup({
					id: '6',
					name: 'Contacts',
					ownerId: getState().profileReducer.getProfile.id
				}))
			}

			if(response.data?.pages?.totalPages > 1){
				dispatch(findNextCollaborators(labelId, ownerId, pageSize, getState().sharingDetailsReducer.collaboratorsPageNumber + 1))
			}

		}).catch(err => {
			console.error("Error fetching collaborators:", err);
			dispatch({
				type: 'FIND_COLLABORATORS',
				payload: { collaborators: [] }
			});
		});
	}
}

export function findNextCollaborators (labelId, ownerId, pageSize, pageNumber) {

	return function(dispatch, getState){

		//let selectedLabelId = null;

		/*if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
			selectedLabelId = 6
		} else {
			selectedLabelId = getState().contactsGroupItemReducer.getSelectedContactsGroup.id;
		}*/

		console.log(labelId);

		if (getState().contactReducer.findCollaborators !== null) {

			let request = '';

			if (pageSize) {
				if(pageNumber){
					request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?pageSize=' + pageSize + '&page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?pageSize=' + pageSize + '&ownerId=' + ownerId;
				}

			} else {
				if(pageNumber) {
					request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?page=' + pageNumber + '&ownerId=' + ownerId;
				} else {
					request = API_GET_GROUP_COLLABORATORS_URL + '/' + labelId + '/groupCollaborators?ownerId=' + ownerId;
				}
			}

			axios.get(request, {withCredentials: true}).then( response => {

				dispatch({
					type: "FIND_NEXT_COLLABORATORS",
					payload: response.data
				});

				let callNextCollaborators = setTimeout(() => {
					if(response.data.pages.next !== null && getState().sharingDetailsReducer.getSharingDetailsPopup.length !== 0){
						if (getState().sharingDetailsReducer.findCollaborators !== null) {
							dispatch(findNextCollaborators(labelId, ownerId, pageSize, response.data.pages.next))
						}
					} else {
						clearTimeout(callNextCollaborators);
					}

				}, 1000);

			});
		}

	}

}

export function enteredCollaboratorSearchValue(string) {
	return {
		type: 'ENTERED_COLLABORATOR_SEARCH_VALUE',
		payload: string
	}
}

export function resetCollaborators() {
	return {
		type: 'FIND_COLLABORATORS',
		payload: null
	}
}

export function selectedCollaborator(object) {
	return {
		type: 'SELECTED_COLLABORATOR',
		payload: object
	};
}

export function collaboratorsPageNumber(int) {
	return {
		type: 'COLLABORATORS_PAGE_NUMBER',
		payload: int
	}
}

export function collaboratorsPageSize(int) {
	return {
		type: 'COLLABORATORS_PAGE_SIZE',
		payload: int
	};
}

export function getSharingDetailsPopup(array) {
	return {
		type: 'GET_SHARING_POPUP',
		payload: array
	}
}

export function getSharingDetailsLv2Popup(array) {
	return {
		type: 'GET_SHARING_LV2_POPUP',
		payload: array
	}
}

export function ownershipChangeTarget(string) {
	return {
		type: 'OWNERSHIP_CHANGE_TARGET',
		payload: string
	}
}

export function getChangedStatus(boolean) {
	return {
		type: 'GET_CHANGED_STATUS',
		payload: boolean
	}
}

export function autoCompleteLoading(boolean) {
	return {
		type: 'AUTO_COMPLETE_LOADING',
		payload: boolean
	}
}

export function getAutoComplete(string) {
	return function (dispatch) {

		axios.get(API_ROOT + '/api/auto?key=' + string, {withCredentials: true}).then(response => {

			if (store.getState().contactReducer.isSearchingContacts) {
				dispatch(isSearchingContacts(false));
			}

			dispatch({
				type: 'GET_AUTO_COMPLETE',
				payload: response.data
			});

			dispatch(autoCompleteLoading(false));

			if (response.data.length > 0) {

				if (document.getElementById('addCollaboratorsField') !== null) {
					let re = new RegExp('(' + document.getElementById('addCollaboratorsField').value.replace(RegExp('(\\/|\\.|\\*|\\+|\\?|\\||\\(|\\)|\\[|\\]|\\{|\\}|\\\\)', 'g'), '\\$1') + ')', 'gi');

					let formattedResults = [];

					for (let i = 0; i < document.getElementsByClassName("js-result").length; i++) {
						let result = document.querySelectorAll('.js-result p')[i];
						result.innerHTML = result.innerText.replace(re, '<span>$1</span>');
						formattedResults.push(result);
					}

					return formattedResults;
				}

			}

		});
	}
}

export function resetAutoComplete() {
	return {
		type: 'GET_AUTO_COMPLETE',
		payload: []
	}
}

export function autoCompleteEnteredValue(string) {
	return {
		type: 'AUTO_COMPLETE_ENTERED_VALUE',
		payload: string
	}
}

export function getSeveralCollaboratorsToAdd(string) {
	return function (dispatch) {
		axios.get(API_ROOT + '/api/auto?key=' + string, {withCredentials: true}).then(response => {
			dispatch({
				type: 'GET_SEVERAL_COLLABORATORS_TO_ADD',
				payload: response.data
			});
			getAddedCollaborators(...response.data);
		})
	}
}

export function removeTheLastAddedCollaborator() {
	return {
		type: 'REMOVE_THE_LAST_ADDED_COLLABORATOR',
	}
}

export function getAddedCollaborators(object) {
	return {
		type: 'GET_ADDED_COLLABORATORS',
		payload: object
	}
}

export function updateAddedCollaborators(object) {
	return {
		type: 'UPDATE_ADDED_COLLABORATORS',
		payload: object
	}
}

export function rightToAdd(string) {

	return function (dispatch) {

		dispatch({
			type: 'RIGHT_TO_ADD',
			payload: string
		});

		let updateCollaboratorsRight = store.getState().sharingDetailsReducer.getAddedCollaborators.map(collaborator => {
			return {
				...collaborator,
				permission: string
			}
		});

		dispatch(updateAddedCollaborators(updateCollaboratorsRight));

	}

}

export function resetAddedCollaborators() {
	return {
		type: 'RESET_ADDED_COLLABORATORS',
	}
}

export function getDeletedCollaborators(object) {
	return {
		type: 'GET_DELETED_COLLABORATORS',
		payload: object
	}
}

export function updateCollaborators(object) {
	return {
		type: 'UPDATE_COLLABORATORS',
		payload: object
	}
}

export function addToContactSwitch(boolean) {
	return {
		type: 'ADD_TO_CONTACT_SWITCH',
		payload: boolean
	}
}

export function invalidShare(boolean) {
	return {
		type: 'INVALID_SHARE',
		payload: boolean
	}
}

export function isNewAddedCollaboratorsLoading(boolean) {
	return {
		type: 'IS_NEW_ADDED_COLLABORATORS_LOADING',
		payload: boolean
	}
}

const isTargetDirectory = () => {
	const popup = store.getState().sharingDetailsReducer.getSharingDetailsPopup;
	const targetLabelId = popup && popup[2];
	if (targetLabelId) {
		const rawLabels = store.getState().contactsGroupItemReducer.findLabels;
		const labels = Array.isArray(rawLabels) ? rawLabels : (rawLabels && Array.isArray(rawLabels.contactsGroups) ? rawLabels.contactsGroups : []);
		const foundLabel = labels.find(l => String(l.id) === String(targetLabelId));
		if (foundLabel) {
			return foundLabel.type === 'directory';
		}
		const dirState = store.getState().contactsGroupItemReducer.findDirectoryGroups;
		if (dirState) {
			if (dirState.rootOu && String(dirState.rootOu.id) === String(targetLabelId)) return true;
			if (dirState.childOu && dirState.childOu.some(ou => String(ou.id) === String(targetLabelId))) return true;
			if (dirState.childOuLv2 && dirState.childOuLv2.some(ou => String(ou.id) === String(targetLabelId))) return true;
		}
		return false;
	}
	if (popup && popup[1] === 'confirm_directory_sharing') return true;
	return false;
};

const isTargetSystem = () => {
	const popup = store.getState().sharingDetailsReducer.getSharingDetailsPopup;
	const targetLabelId = popup && popup[2];
	if (targetLabelId) {
		if (String(targetLabelId) === '6' || String(targetLabelId).startsWith('6-')) return true;
		const rawLabels = store.getState().contactsGroupItemReducer.findLabels;
		const labels = Array.isArray(rawLabels) ? rawLabels : (rawLabels && Array.isArray(rawLabels.contactsGroups) ? rawLabels.contactsGroups : []);
		const foundLabel = labels.find(l => String(l.id) === String(targetLabelId));
		if (foundLabel) {
			return foundLabel.type === 'system';
		}
		return false;
	}
	if (popup && popup[1] === 'confirm_sharing') return true;
	const selected = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
	return selected ? selected.type === 'system' : false;
};

const transitionSharingPopupWithTarget = (dispatch, nextPopupType) => {
	const currentPopup = store.getState().sharingDetailsReducer.getSharingDetailsPopup || [];
	const targetLabelId = currentPopup[2];
	const targetLabelName = currentPopup[3];
	const targetOwnerId = currentPopup[4];
	if (nextPopupType === 'confirm_sharing' || nextPopupType === 'add_user') {
		dispatch(setDetailsForContactCard({}));
	}
	dispatch(isSharing(false));
	dispatch(getSharingDetailsPopup([true, nextPopupType, targetLabelId, targetLabelName, targetOwnerId]));
};

export function share(createdLabelFromContactsSharing) {
	return function (dispatch) {

		const domField = typeof document !== 'undefined' ? document.getElementById('addCollaboratorsField') : null;
		const domFieldValue = domField && domField.value ? domField.value.trim() : '';
		if (
			domFieldValue !== ''
			&& (!store.getState().sharingDetailsReducer.autoCompleteEnteredValue || store.getState().sharingDetailsReducer.autoCompleteEnteredValue.trim() === '')
		) {
			dispatch(autoCompleteEnteredValue(domFieldValue));
		}

		if (store.getState().sharingDetailsReducer.getAddedCollaborators.length > 0) {

			/*if(document.querySelector(".sharing-details-head input")){
				document.querySelector(".sharing-details-head input").value = "";
			}*/

			if (store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.length > 0 && store.getState().contactReducer.targetedContact === null) {

				/*
				* If several contacts group is selected
				* */

				let addedCollaboratorsForSeveralContactsGroup = [];

				store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.forEach(contactGroup => {

					store.getState().sharingDetailsReducer.getAddedCollaborators.forEach(item => {
						addedCollaboratorsForSeveralContactsGroup = addedCollaboratorsForSeveralContactsGroup.concat({
							...item,
							groupId: contactGroup.id,
							addToContact: store.getState().sharingDetailsReducer.addToContactSwitch,
							ownerId: contactGroup.ownerId
						});
					});

				});

				dispatch(postShare({
					collaborators: addedCollaboratorsForSeveralContactsGroup,
					notify: store.getState().sharingDetailsReducer.notify
				}));

			} else {

				/*
				* If only one contact group is selected
				* */

				if (createdLabelFromContactsSharing) {

					let addedCollaborators = store.getState().sharingDetailsReducer.getAddedCollaborators.map(item => {
						return {
							...item,
							groupId: createdLabelFromContactsSharing.id,
							addToContact: store.getState().sharingDetailsReducer.addToContactSwitch
						}
					});

					dispatch(postShare({
						collaborators: addedCollaborators,
						notify: store.getState().sharingDetailsReducer.notify
					}));

				} else {

					if (
						isTargetSystem()
						&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
					) {

						transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

					} else if (
						isTargetDirectory()
						&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
					) {

						transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

					} else {
						let targetLabelId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
							|| (store.getState().contactsGroupItemReducer.selectOneLabelFromPopup && store.getState().contactsGroupItemReducer.selectOneLabelFromPopup.id)
							|| (store.getState().contactsGroupItemReducer.getSelectedContactsGroup && store.getState().contactsGroupItemReducer.getSelectedContactsGroup.id);

						let targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
							|| (store.getState().contactsGroupItemReducer.selectOneLabelFromPopup && store.getState().contactsGroupItemReducer.selectOneLabelFromPopup.ownerId)
							|| (store.getState().contactsGroupItemReducer.getSelectedContactsGroup && store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId)
							|| (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id);

						let addedCollaborators = store.getState().sharingDetailsReducer.getAddedCollaborators.map(item => {

							return {
								...item,
								groupId: targetLabelId || item.groupId,
								addToContact: store.getState().sharingDetailsReducer.addToContactSwitch,
								ownerId: item.ownerId || targetOwnerId
							}
						});

						dispatch(postShare({
							collaborators: addedCollaborators,
							notify: store.getState().sharingDetailsReducer.notify
						}));
					}

				}

			}

		} else if (store.getState().sharingDetailsReducer.autoCompleteEnteredValue && store.getState().sharingDetailsReducer.autoCompleteEnteredValue.trim() !== '') {

			/*
			* If entered collaborator email string without pressing enter key
			* */

			let addCollaboratorsFieldValue = store.getState().sharingDetailsReducer.autoCompleteEnteredValue
				|| (document.getElementById("addCollaboratorsField") ? document.getElementById("addCollaboratorsField").value : "");

			/*
			* If addedCollaborator is empty we can add them on the fly
			* */

			let shareCollaboratorsOnTheFly = (addToContact) => {

				let collaboratorsOnTheFly = addCollaboratorsFieldValue.trim();

				if (collaboratorsOnTheFly.includes(',')) {

					let collaboratorsOnTheFlyArray = collaboratorsOnTheFly.split(',');
					let collaboratorsOnTheFlyToSend = [];

					if (store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.length > 0 && store.getState().contactReducer.targetedContact === null) {

						/*
						* If several contacts group is selected
						* */

						/*
						* @TODO : Look at a possible checkbox
						* document.querySelector('.label[data-type="system"] input[type="checkbox"]').checked
						* */

						if (
							isTargetSystem()
							&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
						) {
							/*
							* If systemGroup is included
							* */

							transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

						} else if (
							isTargetDirectory()
							&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
						) {

							/*
							* If directoryGroup is included
							* */

							transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

						} else {

							let contactsGroupsArray = [];
							let collaboratorsArray = [];

							store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.forEach((contactGroup, index) => {

								contactsGroupsArray = contactsGroupsArray.concat(contactGroup.name);

								collaboratorsOnTheFlyArray.forEach(item => {

									if (index === 0) {
										collaboratorsArray = collaboratorsArray.concat(item);
									}

									if (checkEmailFormat(item)) {

										collaboratorsOnTheFlyToSend = collaboratorsOnTheFlyToSend.concat({
											'groupId': contactGroup.id,
											'id': item,
											'name': '',
											'email': item,
											'permission': store.getState().sharingDetailsReducer.rightToAdd,
											'type': 'user',
											'addToContact': addToContact,
											'toRemove': false,
											'ownerId' : contactGroup.ownerId
										})

									}
								});
							});

							if (collaboratorsOnTheFlyToSend.length > 0) {
								dispatch(postShare({
									collaborators: collaboratorsOnTheFlyToSend,
									notify: store.getState().sharingDetailsReducer.notify
								}));

								if (document.getElementById('addCollaboratorsField')) {
									document.getElementById('addCollaboratorsField').value = '';
								}

							} else if (collaboratorsOnTheFly !== '') {
								dispatch(isEmailValid(false));
							} else {
								dispatch(isEmpty(true));
							}
						}

					} else {

						/*
						* Only one contacts group is selected
						* */

						if (
							isTargetSystem()
							&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
						) {

							transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

						} else if (
							isTargetDirectory()
							&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
						) {

							transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

						} else {
							let collaboratorsArray = [];

							collaboratorsOnTheFlyArray.forEach(item => {

								collaboratorsArray = collaboratorsArray.concat(item);

								if (checkEmailFormat(item)) {
									if (createdLabelFromContactsSharing) {
										collaboratorsOnTheFlyToSend = collaboratorsOnTheFlyToSend.concat({
											'groupId': createdLabelFromContactsSharing.id,
											'id': item,
											'name': '',
											'email': item,
											'permission': store.getState().sharingDetailsReducer.rightToAdd,
											'type': 'user',
											'addToContact': addToContact,
											'toRemove': false,
											'ownerId' : store.getState().profileReducer.getProfile.id
										})
									} else {
										const selGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
										const targetGroupId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
											|| (selGroup ? (selGroup.type === "system" ? 6 : selGroup.id) : 6);
										const targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
											|| (selGroup ? selGroup.ownerId : (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id));

										collaboratorsOnTheFlyToSend = collaboratorsOnTheFlyToSend.concat({
											'groupId': targetGroupId,
											'id': item,
											'name': '',
											'email': item,
											'permission': store.getState().sharingDetailsReducer.rightToAdd,
											'type': 'user',
											'addToContact': addToContact,
											'toRemove': false,
											'ownerId': targetOwnerId
										})
									}

								}
							});

							if (collaboratorsOnTheFlyToSend.length > 0) {
								dispatch(postShare({
									collaborators: collaboratorsOnTheFlyToSend,
									notify: store.getState().sharingDetailsReducer.notify
								}));

								if (document.getElementById('addCollaboratorsField')) {
									document.getElementById('addCollaboratorsField').value = '';
								}

							} else if (collaboratorsOnTheFly !== '') {
								dispatch(isEmailValid(false));
							} else {
								dispatch(isEmpty(true));
							}

						}

					}

				} else {

					/*
					* Only one collaborator added on the fly
					* */

					if (store.getState().sharingDetailsReducer.getAutoComplete.length > 0) {

						if (store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.length > 0 && store.getState().contactReducer.targetedContact === null) {

							/*
							* If several contacts group is selected
							* */

							/*
							* @TODO : Look at a possible checkbox
							* document.querySelector('.label[data-type="system"] input[type="checkbox"]').checked
							* */

							if (
								isTargetSystem()
								&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
							) {
								/*
								* If systemGroup is included
								* */

								transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

							} else if (
								isTargetDirectory()
								&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
							) {

								/*
								* If directoryGroup is included
								* */

								transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

							} else {

								/*
								* Trying to enter on the fly a collaborator that exists in the autocomplete list
								* */

								let knownCollaboratorOnTheFly = [];

								store.getState().sharingDetailsReducer.getAutoComplete.forEach(item => {
									if (item.email === collaboratorsOnTheFly) {

										store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.forEach(contactGroup => {
											knownCollaboratorOnTheFly = knownCollaboratorOnTheFly.concat(
												{
													'groupId': contactGroup.id,
													'id': item.id,
													'name': item.name,
													'email': item.email,
													'permission': store.getState().sharingDetailsReducer.rightToAdd,
													'type': item.type,
													'addToContact': addToContact,
													'toRemove': false,
													'ownerId': contactGroup.ownerId
												}
											);
										});

									}
								});

								if (document.getElementById('addCollaboratorsField')) {
									document.getElementById('addCollaboratorsField').value = '';
								}

								dispatch(postShare({
									collaborators: knownCollaboratorOnTheFly,
									notify: store.getState().sharingDetailsReducer.notify
								}));
							}

						} else {

							/*
							* If only one contact group is selected
							* */

							if (
								isTargetSystem()
								&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
							) {

								transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

							} else if (
								isTargetDirectory()
								&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
							) {

								/*
								* If directoryGroup is included
								* */

								transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

							} else {

								/*
								* Trying to enter on the fly a collaborator that exists in the autocomplete list
								* */

								let knownCollaboratorOnTheFly = [];

								const autoCompleteList = store.getState().sharingDetailsReducer.getAutoComplete;
								autoCompleteList.forEach(item => {
									if (item.email === collaboratorsOnTheFly || item.name === collaboratorsOnTheFly || (collaboratorsOnTheFly.length > 2 && (item.email.includes(collaboratorsOnTheFly) || item.name.includes(collaboratorsOnTheFly)))) {
										const selGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
										const targetGroupId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
											|| (createdLabelFromContactsSharing ? createdLabelFromContactsSharing.id : (selGroup ? (selGroup.type === "system" ? 6 : selGroup.id) : 6));
										const targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
											|| (selGroup ? selGroup.ownerId : (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id));

										knownCollaboratorOnTheFly = knownCollaboratorOnTheFly.concat({
											'groupId': targetGroupId,
											'id': item.id || item.email,
											'name': item.name || '',
											'email': item.email,
											'permission': store.getState().sharingDetailsReducer.rightToAdd,
											'type': item.type || 'user',
											'addToContact': addToContact,
											'toRemove': false,
											'ownerId': targetOwnerId
										});
									}
								});

								if (knownCollaboratorOnTheFly.length === 0 && autoCompleteList.length > 0) {
									const firstItem = autoCompleteList[0];
									const selGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
									const targetGroupId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
										|| (createdLabelFromContactsSharing ? createdLabelFromContactsSharing.id : (selGroup ? (selGroup.type === "system" ? 6 : selGroup.id) : 6));
									const targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
										|| (selGroup ? selGroup.ownerId : (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id));

									knownCollaboratorOnTheFly.push({
										'groupId': targetGroupId,
										'id': firstItem.id || firstItem.email,
										'name': firstItem.name || '',
										'email': firstItem.email,
										'permission': store.getState().sharingDetailsReducer.rightToAdd,
										'type': firstItem.type || 'user',
										'addToContact': addToContact,
										'toRemove': false,
										'ownerId': targetOwnerId
									});
								} else if (knownCollaboratorOnTheFly.length === 0 && checkEmailFormat(collaboratorsOnTheFly)) {
									const selGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
									const targetGroupId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
										|| (createdLabelFromContactsSharing ? createdLabelFromContactsSharing.id : (selGroup ? (selGroup.type === "system" ? 6 : selGroup.id) : 6));
									const targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
										|| (selGroup ? selGroup.ownerId : (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id));

									knownCollaboratorOnTheFly.push({
										'groupId': targetGroupId,
										'id': collaboratorsOnTheFly,
										'name': '',
										'email': collaboratorsOnTheFly,
										'permission': store.getState().sharingDetailsReducer.rightToAdd,
										'type': 'user',
										'addToContact': addToContact,
										'toRemove': false,
										'ownerId': targetOwnerId
									});
								}

								if (document.getElementById('addCollaboratorsField')) {
									document.getElementById('addCollaboratorsField').value = '';
								}

								if (knownCollaboratorOnTheFly.length > 0) {
									dispatch(postShare({
										collaborators: knownCollaboratorOnTheFly,
										notify: store.getState().sharingDetailsReducer.notify
									}));
								} else {
									dispatch(isSharing(false));
								}
							}
						}

					} else {
						if (checkEmailFormat(collaboratorsOnTheFly)) {

							if (store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.length > 0 && store.getState().contactReducer.targetedContact === null) {

								/*
								* If several contacts group is selected
								* */

								/*
								* @TODO : Look at a possible checkbox
								* document.querySelector('.label[data-type="system"] input[type="checkbox"]').checked
								* */

								if (
									isTargetSystem()
									&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
								) {
									/*
									* If systemGroup is included
									* */

									transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

								} else if (
									isTargetDirectory()
									&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
								) {

									/*
									* If directoryGroup is included
									* */

									transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

								} else {

									let contactsGroupsArray = [];

									store.getState().contactsGroupItemReducer.selectSeveralContactsGroups.forEach(contactGroup => {

										contactsGroupsArray = contactsGroupsArray.concat(contactGroup.name);

										dispatch(postShare({
											collaborators: [{
												'groupId': contactGroup.id,
												'id': collaboratorsOnTheFly,
												'name': '',
												'email': collaboratorsOnTheFly,
												'permission': store.getState().sharingDetailsReducer.rightToAdd,
												'type': 'user',
												'addToContact': addToContact,
												'toRemove': false,
												'ownerId': contactGroup.ownerId
											}],
											notify: store.getState().sharingDetailsReducer.notify
										}));
									});

								}

							} else {

								/*
								* Only one contacts group is selected
								* */

								if (createdLabelFromContactsSharing) {
									dispatch(postShare({
										collaborators: [{
											'groupId': createdLabelFromContactsSharing.id,
											'id': collaboratorsOnTheFly,
											'name': '',
											'email': collaboratorsOnTheFly,
											'permission': store.getState().sharingDetailsReducer.rightToAdd,
											'type': 'user',
											'addToContact': addToContact,
											'toRemove': false,
											'ownerId': store.getState().profileReducer.getProfile.id
										}],
										notify: store.getState().sharingDetailsReducer.notify
									}));
									if (document.getElementById('addCollaboratorsField')) {
										document.getElementById('addCollaboratorsField').value = '';
									}
								} else {

									if (
										isTargetSystem()
										&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_sharing'
									) {

										transitionSharingPopupWithTarget(dispatch, 'confirm_sharing');

									} else if (
										isTargetDirectory()
										&& store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] !== 'confirm_directory_sharing'
									) {

										/*
										* If directoryGroup is included
										* */

										transitionSharingPopupWithTarget(dispatch, 'confirm_directory_sharing');

									} else {

										const selGroup = store.getState().contactsGroupItemReducer.getSelectedContactsGroup;
										const targetGroupId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[2])
											|| (selGroup ? (selGroup.type === "system" ? 6 : selGroup.id) : 6);
										const targetOwnerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4])
											|| (selGroup ? selGroup.ownerId : (store.getState().profileReducer.getProfile && store.getState().profileReducer.getProfile.id));

										dispatch(postShare({
											collaborators: [{
												'groupId': targetGroupId,
												'id': collaboratorsOnTheFly,
												'name': '',
												'email': collaboratorsOnTheFly,
												'permission': store.getState().sharingDetailsReducer.rightToAdd,
												'type': 'user',
												'addToContact': addToContact,
												'toRemove': false,
												'ownerId': targetOwnerId
											}],
											notify: store.getState().sharingDetailsReducer.notify
										}));

										if (document.getElementById('addCollaboratorsField')) {
											document.getElementById('addCollaboratorsField').value = '';
										}

									}

								}


							}

						} else if (collaboratorsOnTheFly !== '') {
							dispatch(isEmailValid(false));
						} else {
							dispatch(isEmpty(true));
						}
					}
				}
			};


			if (store.getState().sharingDetailsReducer.addToContactSwitch) {
				shareCollaboratorsOnTheFly(true);
			} else {
				shareCollaboratorsOnTheFly(false);
			}

		} else {
			dispatch(isSharing(false));
			if (
				store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] === 'confirm_sharing'
				|| store.getState().sharingDetailsReducer.getSharingDetailsPopup[1] === 'confirm_directory_sharing'
			) {
				const currentPopup = store.getState().sharingDetailsReducer.getSharingDetailsPopup || [];
				const targetLabelId = currentPopup[2];
				const targetLabelName = currentPopup[3];
				const targetOwnerId = currentPopup[4];
				dispatch(setDetailsForContactCard({}));
				dispatch(getSharingDetailsPopup([true, 'add_user', targetLabelId, targetLabelName, targetOwnerId]));

				if (store.getState().sharingDetailsReducer.autoCompleteEnteredValue !== '') {
					dispatch(isEmailValid(false));
				} else {
					dispatch(isEmpty(true));
				}
			} else {
				dispatch(isEmpty(true));
			}
		}
	}
}

export function postShare(object) {

	return function (dispatch, getState) {

		dispatch(isNewAddedCollaboratorsLoading(true));
		dispatch(isSyncing(true));

		let collaborators = [];

		const normalizedPayload = {
			...object,
			collaborators: Array.isArray(object && object.collaborators)
				? object.collaborators.map((item) => {
					let cleanGroupId = item.groupId;
					let ownerId = item.ownerId;

					if (typeof cleanGroupId === 'string' && cleanGroupId.includes('-') && /^\d+-/.test(cleanGroupId)) {
						const parts = cleanGroupId.split('-');
						cleanGroupId = parts[0];
						if (!ownerId) {
							ownerId = parts[1];
						}
					}

					if (!ownerId) {
						ownerId = (getState().sharingDetailsReducer.getSharingDetailsPopup && getState().sharingDetailsReducer.getSharingDetailsPopup[4])
							|| (getState().contactsGroupItemReducer.getSelectedContactsGroup && getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId)
							|| (getState().profileReducer.getProfile && getState().profileReducer.getProfile.id);
					}

					return {
						...item,
						groupId: cleanGroupId,
						ownerId: ownerId
					};
				})
				: (object && object.collaborators)
		};

		axios.post(API_POST_CONTACT_GROUPS_URL, normalizedPayload, {withCredentials: true}).then(response => {

			const popupAtStart = [...(getState().sharingDetailsReducer.getSharingDetailsPopup || [])];

			let checkGmailAddOnTab = getState().profileReducer.setGmailAddOnData;
			let setActiveLabel = getState().profileReducer.checkActiveGmailAddOnLabel;
			if (checkGmailAddOnTab.action === 'viewNotes' || checkGmailAddOnTab.action === 'addNotes' || checkGmailAddOnTab.action === 'edit' || checkGmailAddOnTab.action === 'share' || checkGmailAddOnTab.action === 'view') {
				window.close();
			}

			/**
			 * close the window of the gmail add on after sharing the contact
			 */

			/*
			* Remove the fact on label creation, add to Mobile & Outlook set to true
			* */

			let err = 0;
			let selectedContactsGroup;

			if(getState().contactsGroupItemReducer.selectOneLabelFromPopup){
				selectedContactsGroup = getState().contactsGroupItemReducer.selectOneLabelFromPopup;
			} else {
				selectedContactsGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;
			}

			dispatch(isNewAddedCollaboratorsLoading(false));

			if(document.querySelectorAll('.list-of-group-body .label')){
				document.querySelectorAll('.list-of-group-body .label').forEach(item => {

					if (item.children[0].children[0].checked) {
						item.children[0].children[0].checked = false;
						if (item.classList.contains('selected')) {
							item.classList.remove('selected');
						}

					}

				});
			}


			dispatch(selectSeveralContactsGroups([]));

			/*
			* Close the popup and reset the collaboratorsPageNumber
			* */

			if (getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0) {

				if(
					getState().sharingDetailsReducer.getSharingDetailsPopup[1] === "confirm_sharing"
					|| getState().sharingDetailsReducer.getSharingDetailsPopup[1] === "confirm_directory_sharing"
				){
					dispatch(getSharingDetailsPopup([]));
				}

				dispatch(setDetailsForContactCard({}));
				if (getState().sharingDetailsReducer.addToContactSwitch === false) {
					dispatch(addToContactSwitch(true));
				}

				dispatch(notify(true));
				if (getState().sharingDetailsReducer.collaboratorsPageNumber > 1) {
					dispatch(collaboratorsPageNumber(1))
				}

			}

			let checkFlashMessage = false;
			let checkFirstShare = false;

			/*
			* When looping all the collaboraotors, take the last sharingResult
			* */

			let lastErrorToCatch = null;


			//let flashArray = [];

			response.data.forEach(item => {

				if (item.sharingResult) {
					err++;

					/*flashArray = flashArray.concat({type:"danger", label: sharedWordRemove(item.groupName), target: (item.name ? item.name : item.email), message: item.sharingResult.message, reason: item.sharingResult.reason});
					dispatch(flash(flashArray));*/

					/*if(getState().profileReducer.getProfile.domain.status === 'EXPIRED_EVAL'){
					dispatch(getSharingDetailsPopup([true, 'expired_eval']));
					dispatch(checkComponentRendering(false));
					checkFlashMessage = true;
					} else {
					dispatch(getSharingDetailsPopup([true, item.sharingResult.message]));
					dispatch(checkComponentRendering(false));
					checkFlashMessage = true;
					}*/

					lastErrorToCatch = item.sharingResult.message;

				} else {

					/*
					* We are going through the response and we push item into collatorators array
					* */

					collaborators = collaborators.concat(item);
				}
			});

			if (err === 0) {

				dispatch(autoCompleteEnteredValue(''));
				dispatch(resetAddedCollaborators());

				// Webful In-App Analytics
				webfulTrack('label_shared');

				if (getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0) {
					if(getState().sharingDetailsReducer.getSharingDetailsPopup[2]){
						dispatch(findCollaborators(getState().sharingDetailsReducer.getSharingDetailsPopup[2], getState().sharingDetailsReducer.collaboratorsPageSize, getState().sharingDetailsReducer.getSharingDetailsPopup[4]));
					} else if (selectedContactsGroup) {
						dispatch(findCollaborators(selectedContactsGroup.id, getState().sharingDetailsReducer.collaboratorsPageSize, selectedContactsGroup.ownerId));
					}
				}

				if (getState().contactsGroupItemReducer.selectSeveralContactsGroups.length > 0 && getState().contactReducer.targetedContact === null) {

					if(getState().popupReducer.isUserListAddCollaboratorsPopupShown){
						dispatch(msgSharingDetailsBar(['success', translate('textMultipleLabelsUpdated')]));
					} else {
						dispatch(flash({type: 'success', message: translate('textMultipleLabelsUpdated')}));
					}

				} else {

					if(getState().contactsGroupItemReducer.selectOneLabelFromPopup){
						if(getState().popupReducer.isUserListAddCollaboratorsPopupShown){
							dispatch(msgSharingDetailsBar(['success', translate("msgShareLabelsSuccessfully")]));
						} else {
							dispatch(flash({
								type: 'success',
								message: sharedWordRemove(getState().contactsGroupItemReducer.selectOneLabelFromPopup.name) + ' ' + translate("msgShareLabelsSuccessfully"),
							}));
						}
					} else {
						if(getState().popupReducer.isUserListAddCollaboratorsPopupShown){
							dispatch(msgSharingDetailsBar(['success', translate("msgShareLabelsSuccessfully")]));
						} else {
							const selGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;
							const rawGroupName = (popupAtStart && popupAtStart[3]) || (selGroup ? selGroup.name : '');
							const groupName = rawGroupName ? sharedWordRemove(rawGroupName) : '';
							dispatch(flash({
								type: 'success',
								message: (groupName ? groupName + ' ' : '') + translate("msgShareLabelsSuccessfully"),
							}));
						}
					}
				}

				let nbrSharedLabels = 0;

				if(getState().directoryGroupReducer.findDirectoryGroups){
					getState().directoryGroupReducer.findDirectoryGroups.directoryContactGroupsV4.find(label => {
						if (label.rootOu.status === 'SHARED') {
							nbrSharedLabels = nbrSharedLabels + 1;
						}

						if(label.rootOu.childOu.length > 0){
							label.rootOu.childOu.find(childOuItem => {
								if (childOuItem.status === 'SHARED') {
									return nbrSharedLabels = nbrSharedLabels + 1;
								}

								if(childOuItem.childOu > 0){
									childOuItem.childOu.find(childOuItemLv2 => {
										if (childOuItemLv2.status === 'SHARED') {
											return nbrSharedLabels = nbrSharedLabels + 1;
										}

										return false;
									})
								}

								return false;
							})
						}

						return false;
					});
				}

				if(getState().contactsGroupItemReducer.findLabels) {
					getState().contactsGroupItemReducer.findLabels.contactsGroups.find(label => {
						if (label.status === 'SHARED') {
							return nbrSharedLabels = nbrSharedLabels + 1;
						}
						return false;
					});
				}

				if(getState().systemGroupReducer.findSystemGroups) {
					getState().systemGroupReducer.findSystemGroups.systemGroups.find(label => {
						if (label.status === 'SHARED') {
							return nbrSharedLabels = nbrSharedLabels + 1;
						}
						return false;
					});
				}

				let gmailFinishLabelPopup = getState().profileReducer.setGmailAddOnData.checkGmailAddon;
				if (nbrSharedLabels === 0) {
					if (window.dataLayer) {
						window.dataLayer.push({
							'shared': 'true',
							event: 'shared'
						});
					}
					dispatch(checkComponentRendering(false));
				}

				if (nbrSharedLabels === 0 && gmailFinishLabelPopup === 'gmailaddon' && !checkFlashMessage) {
					checkFirstShare = true;
					setTimeout(() => {
						dispatch(
							getSharingDetailsPopup([
								true,
								'gmail_finish_first_label_sharing',
							])
						);
					}, 200);
				} else if (nbrSharedLabels === 0 && gmailFinishLabelPopup !== 'gmailaddon') {

					if( window.location.pathname.includes('/label/') || window.location.pathname.includes('/contact/') ){
						if(getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0){
							dispatch(getSharingDetailsPopup([]));
						}
						setTimeout(() => {
							dispatch(getSharingDetailsPopup([true, 'finish_first_label_sharing']));
						}, 2000);
					}


				}

				/*
				* Licenses number is updated
				* */

				dispatch(getProfile());

			} else {

				/*
				* There is some errors
				* */

				dispatch(getSharingDetailsPopup([]));
				dispatch(resetCollaborators());

				const targetLabelId = getState().sharingDetailsReducer.getSharingDetailsPopup[2]
					|| (selectedContactsGroup && selectedContactsGroup.id);
				if (targetLabelId) {
					dispatch(findCollaborators(targetLabelId, getState().sharingDetailsReducer.collaboratorsPageSize));
				}


				if(getState().popupReducer.isUserListAddCollaboratorsPopupShown){
					if (lastErrorToCatch === 'PERMISSION_DENIED') {
						dispatch(msgSharingDetailsBar(['error', translate('invalidSharingPermissionDenied')]));
					} else {
						dispatch(msgSharingDetailsBar(['error', translate('textInvalidStatusForAttachment')]));
					}
				} else {
					if (getState().profileReducer.getProfile.domain.status === 'EXPIRED_EVAL') {
						dispatch(getSharingDetailsPopup([true, 'expired_eval']));
					} else if (getState().profileReducer.getProfile.domain.status === 'EXPIRED_PAID') {
						dispatch(getSharingDetailsPopup([true, 'expired_paid']));
					} else {
						/*
                        * That's an invited user
                        * */
						dispatch(getSharingDetailsPopup([true, lastErrorToCatch]));
					}
				}



				err = 0;
			}

			if ('checkGmailAddon' in checkGmailAddOnTab && setActiveLabel === 'gmail_select_one_label' && !checkFirstShare && !checkFlashMessage) {
				window.close();
			}

			/*
			* Refresh status & labels rendering
			*/

			if (getState().contactsGroupItemReducer.getFilteredStatus !== null) {
				if (getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
					dispatch(labelsPageNumber(1));
					dispatch(findLabelsByType(getState().contactsGroupItemReducer.getFilteredStatus));
				} else {
					dispatch(labelsPageNumber(1));
					dispatch(findLabelsByType(getState().contactsGroupItemReducer.getFilteredStatus, getState().contactsGroupItemReducer.labelsPageSize));
				}
			} else {
				if (getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
					dispatch(labelsPageNumber(1));
					dispatch(findLabels(false, true));
				} else {
					dispatch(labelsPageNumber(1));
					dispatch(findLabels(getState().contactsGroupItemReducer.labelsPageSize, true));
				}
			}

			/*
			* Refresh system labels
			*/

			dispatch(findSystemGroups());

			/*
			* Refresh directory labels
			*/

			dispatch(findDirectoryGroups());

			dispatch(rightToAdd('READ_ONLY'));


			/*
			* All the labels are unselected
			* */

			dispatch(selectSeveralContactsGroups([]));

			document.querySelectorAll('.label input[type="checkbox"]').forEach((item) => {

				if (item.checked) {
					item.checked = false;
				}

				if (item.parentElement.parentElement.classList.contains('selected')) {
					item.parentElement.parentElement.classList.remove('selected');
				}

			});

			/*
			* Include massLabelsSelection
			* */

			if (document.getElementById('massLabelsSelection')) {
				document.getElementById('massLabelsSelection').checked = false;
			}

			/*
			* Refresh users-list if selectOneLabelFromPopup exist
			*/

			if(getState().contactsGroupItemReducer.selectOneLabelFromPopup){
				dispatch(findUsers());
			}


		}).catch(e => {

			/*
			* Close the popup
			* */

			if (getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0) {
				dispatch(getSharingDetailsPopup([]));
				dispatch(setDetailsForContactCard({}));
				if (getState().sharingDetailsReducer.addToContactSwitch === false) {
					dispatch(addToContactSwitch(true));
				}
				dispatch(notify(true));
			}

			if(getState().popupReducer.isUserListAddCollaboratorsPopupShown) {
				dispatch(msgSharingDetailsBar(['error', "Internal error occurred on sharing this label."]));
			} else {
				dispatch(flash({type: 'danger'}));
			}

			dispatch(resetCollaborators());
			dispatch(isNewAddedCollaboratorsLoading(false));

			const targetGroup = getState().contactsGroupItemReducer.selectOneLabelFromPopup
				|| getState().contactsGroupItemReducer.getSelectedContactsGroup;
			const targetLabelId = (getState().sharingDetailsReducer.getSharingDetailsPopup && getState().sharingDetailsReducer.getSharingDetailsPopup[2])
				|| (targetGroup && targetGroup.id);

			if (targetLabelId) {
				dispatch(findCollaborators(targetLabelId, store.getState().sharingDetailsReducer.collaboratorsPageSize));
			}

		}).finally(() => {

			dispatch(isSharing(false));
			dispatch(isNewAddedCollaboratorsLoading(false));
			dispatch(labelStateUpdating(null));
			dispatch(targetedContact(null));

			if (document.getElementById('t3')) {
				document.getElementById('t3').style.transform = 'scale(0)';
			}

			setTimeout(() => {
				dispatch(guidedTours({
					't3': true,
				}));
			}, 500)
		});
	}
}

export function putUpdateCollaborators(object, fromUsersLicensesList, freeLicense) {

	let obj = {};

	obj.collaborators = object.collaborators.map((item) => {
		let cleanGroupId = item.groupId;
		let ownerId = item.ownerId;

		if (typeof cleanGroupId === 'string' && cleanGroupId.includes('-') && /^\d+-/.test(cleanGroupId)) {
			const parts = cleanGroupId.split('-');
			cleanGroupId = parts[0];
			if (!ownerId) {
				ownerId = parts[1];
			}
		}

		if (!ownerId) {
			ownerId = (store.getState().sharingDetailsReducer.getSharingDetailsPopup && store.getState().sharingDetailsReducer.getSharingDetailsPopup[4]) || store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;
		}

		return {
			...item,
			groupId: cleanGroupId,
			ownerId: ownerId
		}
	});

	return function (dispatch, getState) {

		dispatch(isSyncing(true));

		axios.put(API_POST_CONTACT_GROUPS_URL, obj, {withCredentials: true}).then((response) => {

			const popupAtStart = [...(getState().sharingDetailsReducer.getSharingDetailsPopup || [])];

			let err = 0;

			let selectedContactsGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;

			/*
			* The array of Collaborator to update is emptied.
			* */
			//dispatch(updateCollaborators([]));

			response.data.forEach(item => {

				if (item.sharingResult) {
					err++;
					dispatch(flash({
						type: 'danger',
						label: sharedWordRemove(item.hasOwnProperty('groupName') ? item.groupName : ''),
						target: (item.name ? item.name : item.email),
						message: item.sharingResult.message,
						reason: item.sharingResult.reason
					}));
				}

			});

			if (err === 0) {

				/*
				* If that request come from Users List page
				* */

				if (fromUsersLicensesList && freeLicense) {
					dispatch(flash({type: 'success', message: translate('textCollaboratorRelease')}));
				} else if (fromUsersLicensesList) {
					dispatch(flash({type: 'success', message: translate('textCollaboratorRelease')}));
				} else {
					const rawLabelName = (popupAtStart && popupAtStart[3])
						|| (selectedContactsGroup && selectedContactsGroup.name)
						|| '';
					dispatch(flash({
						type: 'success',
						message: translate("msgBarErrorText9").replace("{{labelName}}", sharedWordRemove(rawLabelName))
					}));
					if (getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0 && !getState().sharingDetailsReducer.ownershipChangeTarget) {
						dispatch(getSharingDetailsPopup([]));
						dispatch(getChangedStatus(false));
					}
				}

				dispatch(labelStateUpdating(null));

				if (getState().contactsGroupItemReducer.getFilteredStatus !== null) {
					if (getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
						dispatch(labelsPageNumber(1));
						dispatch(findLabelsByType(getState().contactsGroupItemReducer.getFilteredStatus));
					} else {
						dispatch(labelsPageNumber(1));
						dispatch(findLabelsByType(getState().contactsGroupItemReducer.getFilteredStatus, getState().contactsGroupItemReducer.labelsPageSize));
					}
				} else {
					if (getState().contactsGroupItemReducer.getEnteredSearchValue !== '') {
						dispatch(labelsPageNumber(1));
						dispatch(findLabels(false, true));
					} else {
						dispatch(labelsPageNumber(1));
						dispatch(findLabels(getState().contactsGroupItemReducer.labelsPageSize, true));
					}
				}
				/*
				* Refresh system labels
				*/

				dispatch(findSystemGroups());

				/*
				* Refresh directory labels
				*/

				dispatch(findDirectoryGroups());


			} else {
				err = 0;
			}

			if (getState().sharingDetailsReducer.ownershipChangeTarget !== null) {
				dispatch(ownershipChangeTarget(null))
			}

			//dispatch(resetCollaborators());

			if (getState().sharingDetailsReducer.getSharingDetailsPopup.length > 0) {
				if(getState().sharingDetailsReducer.getSharingDetailsPopup[2]){
					dispatch(findCollaborators(getState().sharingDetailsReducer.getSharingDetailsPopup[2], getState().sharingDetailsReducer.collaboratorsPageSize, getState().sharingDetailsReducer.getSharingDetailsPopup[4]));
				} else if (selectedContactsGroup) {
					dispatch(findCollaborators(selectedContactsGroup.id, getState().sharingDetailsReducer.collaboratorsPageSize, selectedContactsGroup.ownerId));
				}
			}


			/*
			* If that request come from Users List page
			* */

			if (fromUsersLicensesList) {
				dispatch(findUsers(getState().usersListReducer.usersListFilteredStatus, getState().usersListReducer.usersListFilteredLicense));
			}

			dispatch(updateCollaborators([]));

			/*
			* The list of added Collaborators is emptied.
			* */

			dispatch(resetAddedCollaborators());
			dispatch(autoCompleteEnteredValue(''));

			/*
			* Licenses number is updated
			* */

			dispatch(getProfile());

		}).catch(e => {

			/*
			* If that request come from Users List page
			* */

			if (fromUsersLicensesList) {
				dispatch(flash({type: 'danger', message: e.message}));
			} else {
				dispatch(flash({type: 'danger'}));
			}

			dispatch(resetCollaborators());
			dispatch(ownershipChangeTarget(null));

			let selectedContactsGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;
			dispatch(findCollaborators(selectedContactsGroup.id, store.getState().sharingDetailsReducer.collaboratorsPageSize));
			dispatch(updateCollaborators([]));

			/*
			* If the request fails, the popup is closed in order the msgBar error on the background be seen by the user
			* */

			dispatch(getSharingDetailsPopup([]));

		}).finally(() => {

			if (getState().sharingDetailsReducer.collaboratorsPageNumber > 1) {
				dispatch(collaboratorsPageNumber(1))
			}

			dispatch(updatingCollaborators(false));

			if (getState().popupReducer.confirmFreeLicensesPopup !== null) {
				dispatch(confirmFreeLicensesPopup(null))
			}
		})
	}
}

export function checkUpdates() {
	return function (dispatch, getState) {

		if (getState().sharingDetailsReducer.updateCollaborators.length > 0) {
			dispatch(getChangedStatus(true));

			getState().sharingDetailsReducer.updateCollaborators.find(collaborator => {
				if (
					collaborator.permission === 'OWNER'
					&& collaborator.id
					&& collaborator.id !== getState().profileReducer.getProfile.id
					&& getState().contactsGroupItemReducer.getSelectedContactsGroup.status !== 'SHARED_WITH_ME'
				) {
					dispatch(ownershipChangeTarget(collaborator.id));
				}

				return null;
			});

		} else {
			if (getState().sharingDetailsReducer.getChangedStatus) {
				dispatch(getChangedStatus(false));
			}
		}
	}
}

export function flash(array) {
	return {
		type: 'FLASH',
		payload: array
	}
}

export function sharedWithMeDisplayMode(boolean) {
	return {
		type: 'SHARED_WITH_ME_DISPLAY_MODE',
		payload: boolean
	}
}

export function notify(boolean) {
	return {
		type: 'NOTIFY',
		payload: boolean
	}
}

export function updatingCollaborators(boolean) {
	return {
		type: 'UPDATING_COLLABORATORS',
		payload: boolean
	}
}

export function showHiddenFields(boolean) {
	return {
		type: 'SHOW_HIDDEN_FIELDS',
		payload: boolean
	}
}

export function putHiddenFields(object) {
	return function (dispatch, getState) {
		axios.put(API_GET_GROUP_COLLABORATORS_URL + '/hiddenFields', object, {withCredentials: true}).then((response) => {
			dispatch(msgSharingDetailsBar(['success', response.data.message]));

			/*
			* Update collaborators when we are already on show hidden fields page on that we reload data
			* */

			let selectedContactsGroup = getState().contactsGroupItemReducer.getSelectedContactsGroup;

			if (getState().sharingDetailsReducer.getSharingDetailsPopup[2]) {
				dispatch(findCollaborators(getState().sharingDetailsReducer.getSharingDetailsPopup[2], store.getState().sharingDetailsReducer.collaboratorsPageSize));
			} else {
				dispatch(findCollaborators(selectedContactsGroup.id, store.getState().sharingDetailsReducer.collaboratorsPageSize));
			}


			dispatch(selectedCollaborator({
				...getState().sharingDetailsReducer.selectedCollaborator,
				hiddenFields: response.data.hiddenFields
			}));

			dispatch(hiddenFieldsUpdate(response.data.hiddenFields));

		}).catch(e => {
			dispatch(msgSharingDetailsBar(['error', e.response.data.message]));
			dispatch(hiddenFieldsUpdate(getState().sharingDetailsReducer.selectedCollaborator.hiddenFields));
		}).finally(() => {
			dispatch(isHiddenFieldsChanging(false));
			dispatch(isHiddenFieldsUpdating(false));
		})
	}
}

export function isHiddenFieldsChanging(boolean){
	return {
		type: 'IS_HIDDEN_FIELDS_CHANGING',
		payload: boolean
	}
}

export function hiddenFieldsUpdate(object){
	return {
		type: 'HIDDEN_FIELDS_UPDATE',
		payload: object
	}
}

export function isHiddenFieldsUpdating(boolean){
	return {
		type: 'IS_HIDDEN_FIELDS_UPDATING',
		payload: boolean
	}
}

export function isSharing(boolean){
	return {
		type: 'IS_SHARING',
		payload: boolean
	}
}





